// H2O CAMPAIGN COUNTDOWN — added 2026-05-04
// Updates every [data-ends] element with a live "expires in X" countdown.
// On expiry, the element fades out and the page reloads (so PDP fetches fresh
// product state — daemon will have cleared the metafield by then).
//
// Source: _shared/lib/discount-mirror.js writes h2o_discount.ends_at metafield;
// theme reads it and renders <span class="price__h2o-countdown" data-ends="<unix-ts>">.
//
// Exposes window.h2oRunCountdown() for theme JS to call after dynamic re-render
// (e.g., when variant picker swaps the price block).
(() => {
  const ROMANIAN_PLURAL = (n, one, few, many) => {
    n = Math.abs(n);
    if (n === 1) return one;
    if (n === 0 || (n >= 2 && n <= 19)) return few;
    return many;
  };

  function formatRemaining(secs) {
    if (secs <= 0) return '';
    const days = Math.floor(secs / 86400);
    const hours = Math.floor((secs % 86400) / 3600);
    const mins = Math.floor((secs % 3600) / 60);
    if (days >= 1) {
      const dWord = ROMANIAN_PLURAL(days, 'zi', 'zile', 'de zile');
      return `Expiră în ${days} ${dWord}, ${hours}h`;
    }
    if (hours >= 1) {
      const hWord = ROMANIAN_PLURAL(hours, 'oră', 'ore', 'de ore');
      return `Expiră în ${hours} ${hWord}, ${mins}min`;
    }
    if (mins >= 1) {
      const mWord = ROMANIAN_PLURAL(mins, 'minut', 'minute', 'de minute');
      return `Expiră în ${mins} ${mWord}`;
    }
    const s = Math.max(secs, 0);
    return `Expiră în ${s} sec`;
  }

  function tick() {
    const els = document.querySelectorAll('.price__h2o-countdown[data-ends]');
    const now = Math.floor(Date.now() / 1000);
    let anyExpired = false;
    for (const el of els) {
      const ends = parseInt(el.getAttribute('data-ends'), 10);
      if (!ends) continue;
      const remaining = ends - now;
      if (remaining <= 0) {
        el.textContent = '';
        anyExpired = true;
      } else {
        el.textContent = formatRemaining(remaining);
        if (remaining < 86400) el.classList.add('h2o-countdown--urgent');
        else el.classList.remove('h2o-countdown--urgent');
      }
    }
    if (anyExpired) {
      // Smooth fade-out before reload (premium feel — no jarring instant disappearance)
      els.forEach(el => {
        const ends = parseInt(el.getAttribute('data-ends'), 10);
        if (ends && ends - now <= 0) el.classList.add('h2o-expired');
      });
      // Same goes for badge + price block — give time for fade
      document.querySelectorAll('.price--has-h2o-campaign').forEach(p => {
        p.style.transition = 'opacity 600ms cubic-bezier(0.32, 0.72, 0, 1)';
        p.style.opacity = '0.4';
      });
      setTimeout(() => location.reload(), 800);
    }
    // Also: if any [data-h2o-starts] exists with start time imminent (within 60s), schedule a reload at start.
    // This lets pages waiting for a sale activation refresh exactly when sale begins.
    const startEls = document.querySelectorAll('[data-h2o-starts]');
    for (const el of startEls) {
      const starts = parseInt(el.getAttribute('data-h2o-starts'), 10);
      if (!starts) continue;
      const tilStart = starts - now;
      if (tilStart > 0 && tilStart < 65 && !el.dataset.h2oReloadScheduled) {
        el.dataset.h2oReloadScheduled = '1';
        setTimeout(() => location.reload(), (tilStart + 2) * 1000);
      }
    }
  }

  // Expose for dynamic re-render scenarios (e.g., variant change replacing the price block)
  window.h2oRunCountdown = tick;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { tick(); setInterval(tick, 60000); });
  } else {
    tick();
    setInterval(tick, 60000);
  }
})();
